import icon from "refractor/icon";
export default icon;